import Resource from './Resource'
import { orderBy } from 'lodash'
import { TextNormalization } from '@/shared/util/text-normalization'

class RegimeResource extends Resource {
    async lightList(params) {
        const response = await this.axios.get('/regimes/index', { params })
        return orderBy(response.data, element => TextNormalization.removeDiacritics(element.name), ['asc'])
    }
    async list() {
        const response = await this.axios.get('/regimes/')
        return response.data
    }
}

export default new RegimeResource()
